<template>
  <div class="chart-panel">
    <Chart :cdata="cdata" />
  </div>
</template>

<script>
import Chart from './chart.vue';
import * as api from '@/api/index'
export default {
  props: {
    data: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      cdata: {
        seriesData: [],
        data: []
      }
    }
  },
  watch: {
    data: {
      async handler(newv, oldv) {
        // console.log(newv, '缁囩墿鍒嗘瀽---------------')
        if (newv) {
          // xAias鏁扮粍
          const xAias = ['0-20', '21-40', '41-60', '61-80', '81-100', '101-120', '121-140'];
          const arr = await api.getCategoryPage()
          const list = arr.data

          // console.log(this.addNumbersByRange(newv, xAias), 'result');
          // this.cdata.data = this.addNumbersByRange(newv, xAias)
  
          let categorys = Array.from(list,({name})=>name)
          let arrs = categorys.map((item,index)=>{
            return new Array(categorys.length).fill(0)
          })

          newv.forEach(function(item,index){
              for(var j in item.numCategory){
                      let idx = categorys.indexOf(j)
                      arrs[idx][index] = item.numCategory[j]
              }
          })


          this.cdata.data = arrs
          list.reverse()
          this.cdata.seriesData = list
          // console.error('ggggggggggggggg',this.cdata.data,arrs,list)
          // newv.map(v => {
          //   this.cdata.seriesData.push(v.categoryName)
          // })
        }
      },
      deep: true,
      immediate: true,
    }
  },
  components: {
    Chart,
  },
  mounted() {

  },
  methods: {
    addNumbersByRange(arr, xAias) {
      const rangeIndexes = xAias.map((range) => {
        const [start, end] = range.split("-").map(Number);
        return { start, end };
      });

      const newArr = new Array(arr.length)
        .fill(0)
        .map(() => new Array(xAias.length).fill(0));

      arr.forEach((item, index) => {
        rangeIndexes.forEach((range, idx) => {
          if (item.num >= range.start && item.num <= range.end) {
            newArr[index][idx] = item.num;
          }
        });
      });

      return newArr;
    }
  }
}



</script>

<style lang="scss" scoped>
.chart-panel {
  width: 100%;
  height: 100%;
}
</style>

